import type { VendorErrorCodeResponseDto } from '@evimo/client/models';
import type { VendorErrorCodeFormValues } from '~/app/components/errorManagement/ErrorManagementPage/types';

export {
  buildCreateRequestPayload,
  buildUpdateRequestPayload,
  isConflictError,
} from '~/app/components/errorManagement/ErrorManagementPage/request-payload';
export type { VendorErrorCodeWritePayload } from '~/app/components/errorManagement/ErrorManagementPage/request-payload';

/** Ant Design Tag color tokens for vendor error severity. */
export function severityTagColor(severity: string | null | undefined): string {
  switch (severity) {
    case 'INFO':
      return 'blue';
    case 'WARN':
      return 'orange';
    case 'ERR':
      return 'red';
    case 'FATAL':
      return 'magenta';
    case 'UNKNOWN_EVENT':
      return 'default';
    default:
      return 'default';
  }
}

/** Ant Design Tag color tokens for vendor error source. */
export function sourceTagColor(source: string | null | undefined): string {
  switch (source) {
    case 'MANUAL':
      return 'geekblue';
    case 'UNRESOLVED_QUEUE':
      return 'gold';
    default:
      return 'default';
  }
}

export function toFormValues(
  record: VendorErrorCodeResponseDto,
): VendorErrorCodeFormValues {
  return {
    manufacturerId: record.manufacturerId,
    assetTypeId: record.assetTypeId,
    errorCode: record.errorCode,
    matchType: record.matchType ?? undefined,
    matchKey: record.matchKey ?? undefined,
    vendorErrorCode: record.vendorErrorCode ?? undefined,
    info: record.info ?? undefined,
    parameter: record.parameter ?? undefined,
    state: record.state ?? undefined,
    impactedComponent: record.impactedComponent ?? undefined,
    category: record.category ?? undefined,
    severity: record.severity ?? undefined,
    firmwareVersion: record.firmwareVersion ?? undefined,
    description: record.description ?? undefined,
  };
}

export function formatDisplayValue(
  value: string | Date | null | undefined,
): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  if (value instanceof Date) {
    return value.toLocaleString();
  }
  const asDate = new Date(value);
  if (
    typeof value === 'string' &&
    !Number.isNaN(asDate.getTime()) &&
    /^\d{4}-\d{2}-\d{2}T/.test(value)
  ) {
    return asDate.toLocaleString();
  }
  return value;
}
